import { DateHelper } from "../../../../library-js/date/DateHelper";

export class ISOTimeStamp
{
  value:string;

  static toDate( stamp:ISOTimeStamp ):Date
  {    
    return new Date( stamp.value );
  }

  static fromDate( date:Date ):ISOTimeStamp
  {
    let stamp = new ISOTimeStamp();
    stamp.value = date.toISOString();
    return stamp;
  }

  static now():ISOTimeStamp
  {
    return ISOTimeStamp.fromDate( DateHelper.now() );
  }
}
